import React, { useCallback, useEffect, useRef, useState } from "react";
import BlackTooltip from "@components/tooltip/BlackTooltip";

/**
 * @typedef {Object} OverflowTooltipTextProps
 * @property {React.ReactNode} text
 * @property {string=} className
 * @property {boolean=} arrow
 * @property {React.ComponentProps<typeof BlackTooltip>["placement"]=} placement
 */

/**
 * @param {OverflowTooltipTextProps} props
 */
const OverflowTooltipText = ({ text, className, placement = "top", arrow = false }) => {
  const textRef = useRef(null);
  const [isOverflowed, setIsOverflowed] = useState(false);

  const checkOverflow = useCallback(() => {
    const element = textRef.current;

    if (!element) {
      return;
    }

    setIsOverflowed(
      element.scrollWidth > element.clientWidth ||
      element.scrollHeight > element.clientHeight
    );
  }, []);

  useEffect(() => {
    checkOverflow();
    window.addEventListener("resize", checkOverflow);

    return () => window.removeEventListener("resize", checkOverflow);
  }, [checkOverflow, text]);

  const content = (
    <span ref={textRef} className={`arh-block arh-min-w-0 ${className}`}>
      {text}
    </span>
  );

  if (!isOverflowed) {
    return content;
  }

  return (
    <BlackTooltip title={text} placement={placement} arrow={arrow}>
      {content}
    </BlackTooltip>
  );
};

export default OverflowTooltipText;
